import {
  DeleteOutlined,
  EditOutlined,
  InboxOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Switch,
  Upload,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { debounce } from "lodash";
import { useCallback } from "react";
import Table from "../../../core/common/dataTable/index";
import Preloader from "../../../core/common/loader/preLoader";
import Toasts from "../../../core/common/toast";
import DeleteModal from "../../../core/modals/deleteModal";
import {
  getAllAnnouncements,
  saveSchedular,
  upsertAnnouncement,
} from "../../../core/data/redux/announcementSlice";
import { BASE_URLS } from "../../../core/data/redux/apis/urls";
import Api from "../../../core/data/redux/utils/apiCall";
import { all_routes } from "../../router/all_routes";
import dayjs from "dayjs";
import PermissionGuard from "../../permissionGuard";
import { isSupportViewer } from "../../../utils/permissionUtils";
const routes = all_routes;
const { TextArea } = Input;

interface Announcement {
  id?: string;
  title: string;
  category: string;
  description: string;
  type: string;
  designation: string;
  wing: string;
  department: string;
  isActive: boolean;
  image?: string;
  imageFile?: any;
  pdf?: string;
  pdfFile?: any;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
  start_date?: string;
  end_date?: string;
}

const AnnouncementList: React.FC = () => {
  const { Option } = Select;

  const [wing, setWing] = useState(null);
  const [department, setDepartment] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [deleteId, setDeleteId] = React.useState<any>(null);
  const dispatch = useDispatch();
  const announcementState = useSelector(
    (state: any) => state.announcementState
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingId, setEditingId] = useState<string | null>(null);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showDeleteToast, setShowDeleteToast] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [fileList, setFileList] = useState<any[]>([]);
  const [pdfFileList, setPdfFileList] = useState<any[]>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [searchText, setSearchText] = useState("");

  const [isNotifyModalVisible, setIsNotifyModalVisible] = useState(false);
  const [notifyForm] = Form.useForm();
  const [notifyRecord, setNotifyRecord] = useState<Announcement | null>(null);
  const [csvFileList, setCsvFileList] = useState<any[]>([]);

  const announcementData = announcementState?.data || null;
  const createData = announcementState?.createData || null;
  const updateData = announcementState?.updateData || null;

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = (page = pagination.current, limit = pagination.pageSize, title = searchText) => {
    dispatch(getAllAnnouncements({
      page,
      limit,
      ...(title && { title }),
    }));
  };

  useEffect(() => {
    if (announcementState.loading === "rejected") {
      toast.error(announcementState?.error);
    } else if (
      announcementState.loading === "fulfilled" &&
      announcementState.action === "save_Schedular"
    ) {
      toast.success(
        announcementState?.data?.message || "Schedular saved successfully"
      );
    } else if (
      announcementState.action === "create" &&
      announcementState.loading === "fulfilled"
    ) {
      const isUpdate = editingId !== null;
      const message = isUpdate
        ? "Announcement updated successfully!"
        : "Announcement created successfully!";

      setSuccessMessage(message);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 4000);
      setIsModalVisible(false);
      form.resetFields();
      setEditingId(null);
      dispatch(getAllAnnouncements({
        page: pagination.current,
        limit: pagination.pageSize,
        title: searchText,
      }));
    }
  }, [announcementState.action, announcementState.loading, editingId]);

  useEffect(() => {
    if (announcementData) {
      const apiResponse = announcementData?.data;
      const data = apiResponse?.data?.data || apiResponse || [];
      const total =
        apiResponse?.total || (Array.isArray(data) ? data.length : 0);
      setPagination((prev) => ({
        ...prev,
        total: total,
      }));
    }
  }, [announcementData]);

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      render: (_: any, __: any, index: number) => (
        <div>{(pagination.current - 1) * pagination.pageSize + index + 1}</div>
      ),
      width: 80,
    },
    {
      title: "Title",
      dataIndex: "title",
      render: (title: string) => (
        <div
          style={{
            fontWeight: 500, maxWidth: "200px", whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
          }}
        >
          {title || "-"}
        </div>
      ),
      sorter: (a: Announcement, b: Announcement) =>
        (a.title || "").localeCompare(b.title || ""),
    },
    {
      title: "Category",
      dataIndex: "category",
      render: (category: string) => (
        <span
          style={{
            backgroundColor: "#f0f0f0",
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
          }}
        >
          {category || "-"}
        </span>
      ),
      sorter: (a: Announcement, b: Announcement) =>
        (a.category || "").localeCompare(b.category || ""),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (type: string) => (
        <span
          style={{
            backgroundColor: "#e6f7ff",
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            color: "#1890ff",
          }}
        >
          {type || "-"}
        </span>
      ),
    },
    {
      title: "Department",
      dataIndex: "department",
      render: (department: string) => (
        <span
          style={{
            backgroundColor: "#f6ffed",
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            color: "#52c41a",
          }}
        >
          {department || "-"}
        </span>
      ),
    },
    {
      title: "Designation",
      dataIndex: "designation",
      render: (designation: string) => (
        <span
          style={{
            backgroundColor: "#fff7e6",
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            color: "#fa8c16",
          }}
        >
          {designation || "-"}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (_: any, record: Announcement) => (
        <span
          className={`badge ${record.isActive ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {record.isActive ? "Active" : "Inactive"}
        </span>
      ),
      sorter: (a: Announcement, b: Announcement) =>
        Number(a.isActive) - Number(b.isActive),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (date: string) => (
        <div style={{ fontSize: "12px" }}>
          {date
            ? new Date(date).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            : "N/A"}
        </div>
      ),
      sorter: (a: Announcement, b: Announcement) =>
        new Date(a.created_at || 0).getTime() -
        new Date(b.created_at || 0).getTime(),
    },
    ...(!isSupportViewer()
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            render: (_: any, record: Announcement) => (
              <Space>
                <PermissionGuard route="announcements/edit">
                  <Button
                    icon={<EditOutlined />}
                    onClick={() => handleEdit(record)}
                    size="small"
                  />
                </PermissionGuard>
                <PermissionGuard route="announcements/delete">
                  <Link to="#" data-bs-toggle="modal" data-inert={true} data-bs-target="#delete_modal" onClick={() => setDeleteId(record.id)}>
                    <i className="ti ti-trash" />
                  </Link>
                </PermissionGuard>
                <Button
                  type="primary"
                  icon={<InboxOutlined />}
                  onClick={() => handleNotify(record)}
                  size="small"
                >
                  Notify
                </Button>
              </Space>
            ),
            width: 140,
          },
        ]
      : []),
  ];

  const handleAdd = () => {
    setEditingId(null);
    form.resetFields();
    setFileList([]);
    setPdfFileList([]);
    form.setFieldsValue({
      isActive: false,
    });
    setIsModalVisible(true);
  };

  const getPresignedUrl = async (key: any) => {
    try {
      setIsLoading(true);
      const endPoint = `${BASE_URLS.BASE_URL}aws-bucket/get-presigned-url`;
      const response = await Api.post(`${endPoint}`, { key });
      setIsLoading(false);
      return response.data;
    } catch (error: any) {
      setIsLoading(false);
      return "";
    }
  };

  const getDepartment = async (wing: any) => {
    try {
      const endPoint = `${BASE_URLS.BASE_URL}masters/find-all-departments-by-wing`;
      const response = await Api.post(`${endPoint}`, { wing });
      return response.data;
    } catch (error: any) {
      return [];
    }
  };

  React.useEffect(() => {
    setDepartments([]);
    setDepartment(null);
    form.setFieldsValue({ department: null });
    const fetchDepartment = async () => {
      try {
        const response = await getDepartment(wing);
        setDepartments(response?.data || []);
      } catch (error) {
        console.error("Error fetching department:", error);
      }
    };

    if (wing) {
      fetchDepartment();
    }
  }, [wing]);

  const handleEdit = async (record: Announcement) => {
    setEditingId(record.id || null);
    form.setFieldsValue({
      title: record.title,
      category: record.category,
      description: record.description,
      type: record.type,
      designation: record.designation,
      department: record.department,
      wing: record.wing,
      isActive: record.isActive,
      start_date: record.start_date ? dayjs(record.start_date) : null,
      end_date: record.end_date ? dayjs(record.end_date) : null,
    });

    // Handle existing image if present
    if (record.image) {
      setFileList([
        {
          uid: "-1",
          name: "existing-image",
          status: "done",
          url: await getPresignedUrl(record.image),
        },
      ]);
    } else {
      setFileList([]);
    }

    // Handle existing PDF if present
    if (record.pdf) {
      setPdfFileList([
        {
          uid: "-1",
          name: "existing-pdf",
          status: "done",
          url: await getPresignedUrl(record.pdf),
        },
      ]);
    } else {
      setPdfFileList([]);
    }

    setIsModalVisible(true);
  };

  const handleDelete = async (response: string) => {


    if (response === "YES" && deleteId) {
      try {
        setIsLoading(true);
        const endPoint = `${BASE_URLS.BASE_URL}announcement/remove`;
        const response = await Api.post(`${endPoint}`, { id: deleteId });
        setIsLoading(false);
        console.log('response?.data', response?.data)
        toast.success(response?.data?.message)
        fetchAnnouncements()
        return response.data;
      } catch (error: any) {
        setIsLoading(false);
        return "";
      }
    }
  };

  const handleNotify = (record: Announcement) => {
    setNotifyRecord(record);
    notifyForm.resetFields();
    setCsvFileList([]);
    setIsNotifyModalVisible(true);
  };

  const handleNotifyOk = async () => {
    setIsLoading(true);
    try {
      const values = await notifyForm.validateFields();
      // Handle notification logic here
      console.log("Notify with values:", values);
      const fileObj = values.csv.file;
      if (!fileObj) {
        setIsLoading(false);
        toast.error("Please select a CSV file to upload");
        throw new Error("No CSV file selected");
      }

      // Convert file to base64
      const base64CsvFile = await fileToBase64(fileObj);
      const payload: any = {
        announcement_id: notifyRecord?.id,
        notification_type: values.notificationType,
        schedular_time: values.date,
        csv_file: base64CsvFile,
      };
      dispatch(saveSchedular(payload));
      setIsNotifyModalVisible(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error("Please select a CSV file to upload");
      console.log("Notify with values:", error);
    }
  };

  const handleNotifyCancel = () => {
    setIsNotifyModalVisible(false);
    setNotifyRecord(null);
    setCsvFileList([]);
  };

  // Helper to convert file to base64
  const fileToBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();

      const payload: any = {
        title: values.title,
        category: values.category,
        description: values.description,
        type: values.type,
        designation: values.designation,
        department: values.department,
        wing: values.wing,
        isActive: values.isActive,
        start_date: values.start_date ? values.start_date.format("YYYY-MM-DD") : null,
        end_date: values.end_date ? values.end_date?.format("YYYY-MM-DD") : null,
      };

      console.log("Values---------:", values);
      console.log("payload---------:", payload);

      // Convert image to base64 if present
      if (fileList.length > 0 && fileList[0].originFileObj) {
        payload.imageBase64 = await fileToBase64(fileList[0].originFileObj);
      } else if (fileList.length > 0 && fileList[0].url) {
        payload.image = fileList[0].url;
      }

      // Convert PDF to base64 if present
      if (pdfFileList.length > 0 && pdfFileList[0].originFileObj) {
        payload.pdfBase64 = await fileToBase64(pdfFileList[0].originFileObj);
      } else if (pdfFileList.length > 0 && pdfFileList[0].url) {
        payload.pdf = pdfFileList[0].url;
      }

      if (editingId) {
        payload.id = editingId;
      }

      dispatch(upsertAnnouncement(payload));
    } catch (error) {
      // Form validation errors are handled by Antd automatically
    }
  };

  // const handlePagination = (paginationConfig: any) => {
  //   setPagination({
  //     current: paginationConfig.current,
  //     pageSize: paginationConfig.pageSize,
  //     total: paginationConfig.total,
  //   });

  // };

  const debouncedFetch = useCallback(
    debounce((resetPagination: boolean, value: string) => {
      if (resetPagination) {
        setPagination(prev => ({ ...prev, current: 1 }));
        fetchAnnouncements(1, pagination.pageSize, value);
      } else {
        fetchAnnouncements(pagination.current, pagination.pageSize, value);
      }
    }, 500),
    [pagination.pageSize, pagination.current]
  );

  const handleSearch = (value: string) => {
    setSearchText(value);
    debouncedFetch(true, value);
  };

  const handlePagination = (newPagination: any) => {
    setPagination((prev) => {
      const isPageSizeChanged = prev.pageSize !== newPagination.pageSize;
      const updatedPagination = {
        current: isPageSizeChanged ? 1 : newPagination.current || 1,
        pageSize: newPagination.pageSize,
        total: newPagination.total || prev.total,
      };
      dispatch(getAllAnnouncements({
        page: updatedPagination.current,
        limit: updatedPagination.pageSize,
        title: searchText,
      }));
      return updatedPagination;
    });
  };

  const getTableData = () => {
    if (announcementData) {
      let data = null;
      if (
        announcementData?.data?.data?.data &&
        Array.isArray(announcementData.data.data.data)
      ) {
        data = announcementData.data.data.data;
      } else if (
        announcementData?.data?.data &&
        Array.isArray(announcementData.data.data)
      ) {
        data = announcementData.data.data;
      } else if (
        announcementData?.result &&
        Array.isArray(announcementData.result)
      ) {
        data = announcementData.result;
      } else if (
        announcementData?.data &&
        Array.isArray(announcementData.data)
      ) {
        data = announcementData.data;
      } else if (Array.isArray(announcementData)) {
        data = announcementData;
      } else {
        const dataObj = announcementData.data;
        for (const key in dataObj) {
          if (Array.isArray(dataObj[key])) {
            data = dataObj[key];
            break;
          }
        }

        if (!data) {
          data = [];
        }
      }

      return Array.isArray(data) ? data : [];
    }
    return [];
  };

  const tableData = getTableData();

  return (
    <div className="page-wrapper">
      <Toasts
        show={showSuccessToast}
        message={successMessage}
        title={"Success"}
        type={"success"}
      />
      <Toasts
        show={showDeleteToast}
        message="Delete announcement functionality will be implemented with API integration"
        title={"Info"}
        type={"warning"}
      />

      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Announcements</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Administration</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Announcements
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
            <PermissionGuard route="announcements/create">
              <Button
                type="primary"
                onClick={handleAdd}
                icon={<PlusOutlined />}
                style={{
                  backgroundColor: "#c0282c",
                  border: "1px solid #c0282c",
                  fontWeight: "500",
                }}
              >
                Add Announcement
              </Button>
            </PermissionGuard>
          </div>
        </div>

        <div className="card">
          <div className="card-body p-0 py-3">
            <Table
              columns={columns}
              dataSource={tableData}
              Selection={false}
              paginationConfig={pagination}
              handlePagination={handlePagination}
              loading={announcementState.loading === "pending"}
              handleSearch={handleSearch}
              searchValue={searchText}
            />
          </div>
        </div>

        <Modal
          title={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <i className={`ti ti-${editingId ? "edit" : "plus"}`} />
              {editingId ? "Edit Announcement" : "Add New Announcement"}
            </div>
          }
          open={isModalVisible}
          onOk={handleModalOk}
          onCancel={() => {
            setIsModalVisible(false);
            form.resetFields();
            setFileList([]);
            setPdfFileList([]);
            setEditingId(null);
          }}
          confirmLoading={announcementState.loading === "pending"}
          width={700}
          okText={editingId ? "Update" : "Create"}
          cancelText="Cancel"
        >
          <Form form={form} layout="vertical">
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="title"
                  label="Title"
                  rules={[
                    {
                      required: true,
                      message: "Please input announcement title!",
                    },
                    { min: 3, message: "Title must be at least 3 characters!" },
                    {
                      max: 200,
                      message: "Title cannot exceed 200 characters!",
                    },
                  ]}
                >
                  <Input placeholder="Enter announcement title" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name="description"
              label="Description"
              rules={[
                { required: true, message: "Please input description!" },
                {
                  min: 10,
                  message: "Description must be at least 10 characters!",
                },
                {
                  max: 2000,
                  message: "Description cannot exceed 2000 characters!",
                },
              ]}
            >
              <TextArea
                placeholder="Enter announcement description"
                rows={4}
                showCount
                maxLength={2000}
              />
            </Form.Item>

            <Form.Item
              name="image"
              label="Image"
              extra="Upload an image for the announcement (optional)"
            >
              <Upload.Dragger
                name="image"
                listType="picture"
                fileList={fileList}
                beforeUpload={(file) => {
                  const isImage = file.type.startsWith("image/");
                  if (!isImage) {
                    message.error("You can only upload image files!");
                    return false;
                  }
                  const isLt5M = file.size / 1024 / 1024 < 5;
                  if (!isLt5M) {
                    message.error("Image must be smaller than 5MB!");
                    return false;
                  }
                  return false; // Prevent auto upload
                }}
                onChange={({ fileList: newFileList }) => {
                  setFileList(newFileList.slice(-1)); // Keep only the last file
                }}
                onRemove={() => {
                  setFileList([]);
                }}
                accept="image/*"
                maxCount={1}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag image to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for single image upload. Accepted formats: JPG, PNG,
                  GIF (max 5MB)
                </p>
              </Upload.Dragger>
            </Form.Item>

            <Form.Item
              name="pdf"
              label="PDF"
              extra="Upload a PDF file for the announcement (optional)"
            >
              <Upload.Dragger
                name="pdf"
                listType="text"
                fileList={pdfFileList}
                beforeUpload={(file) => {
                  const isPdf = file.type === "application/pdf";
                  if (!isPdf) {
                    message.error("You can only upload PDF files!");
                    return false;
                  }
                  const isLt5M = file.size / 1024 / 1024 < 5;
                  if (!isLt5M) {
                    message.error("PDF must be smaller than 5MB!");
                    return false;
                  }
                  return false; // Prevent auto upload
                }}
                onChange={({ fileList: newFileList }) => {
                  setPdfFileList(newFileList.slice(-1)); // Keep only the last file
                }}
                onRemove={() => {
                  setPdfFileList([]);
                }}
                accept="application/pdf"
                maxCount={1}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag PDF to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for single PDF upload. Accepted format: PDF (max 5MB)
                </p>
              </Upload.Dragger>
            </Form.Item>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="type"
                  label="Type"
                  rules={[
                    { required: true, message: "Please input type!" },
                    { max: 100, message: "Type cannot exceed 100 characters!" },
                  ]}
                >
                  <Input placeholder="Enter type (e.g., general, emergency, scheduled)" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="category"
                  label="Category"
                  rules={[
                    { required: true, message: "Please select a category!" },
                  ]}
                >
                  <Select placeholder="Select category">
                    <Select.Option value="News">News</Select.Option>
                    <Select.Option value="Events">Events</Select.Option>
                    <Select.Option value="Circular">Circular</Select.Option>
                    <Select.Option value="Training">Training</Select.Option>
                    <Select.Option value="Important Update">Important Update</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="wing" label="Wing">
                  <Select
                    placeholder="Select wing"
                    onChange={(value) => setWing(value || "")}
                  >
                    <Select.Option value="">Select</Select.Option>
                    <Select.Option value="Maintenance">
                      Maintenance
                    </Select.Option>
                    <Select.Option value="Projects">Projects</Select.Option>
                    <Select.Option value="Operations">Operations</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="department"
                  label="Department"
                  rules={[
                    {
                      max: 100,
                      message: "Department cannot exceed 100 characters!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select department"
                    optionFilterProp="children"
                    onChange={(department) => setDepartment(department)}
                    filterOption={(input: any, option: any) =>
                      (option?.children ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    value={department}
                    style={{ width: "100%" }}
                  >
                    {departments &&
                      departments.length > 0 &&
                      departments.map((dept: any) => (
                        <Option
                          key={
                            dept.sap_department_designation_wings_department_id
                          }
                          value={
                            dept.sap_department_designation_wings_department_id
                          }
                        >
                          {
                            dept.sap_department_designation_wings_department_name
                          }
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>




            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="start_date" label="Start Date" rules={[
                  { required: true, message: "Please select start date!" },
                ]}>
                  <DatePicker
                    style={{ width: "100%" }}
                    format="YYYY-MM-DD"
                    allowClear
                    placeholder="Select date and time"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="end_date" label="End Date">
                  <DatePicker
                    style={{ width: "100%" }}
                    format="YYYY-MM-DD"
                    allowClear
                    placeholder="Select date and time"
                  />
                </Form.Item>
              </Col>


            </Row>




            <Row gutter={16}>
              <Col span={12}>
                <PermissionGuard route="announcements/edit">
                  <Form.Item
                    name="isActive"
                    label="Status"
                    valuePropName="checked"
                  >

                    <Switch
                      checkedChildren="Active"
                      unCheckedChildren="Inactive"
                    />

                  </Form.Item>
                </PermissionGuard>
              </Col>
            </Row>
          </Form>
        </Modal>

        <Modal
          title="Send Notification"
          open={isNotifyModalVisible}
          onOk={handleNotifyOk}
          onCancel={handleNotifyCancel}
          okText="Send"
          cancelText="Cancel"
        >
          <Form form={notifyForm} layout="vertical">
            <Form.Item
              name="notificationType"
              label="Notification Type"
              rules={[
                { required: true, message: "Please select notification type!" },
              ]}
            >
              <Select placeholder="Select notification type">
                <Select.Option value="push">Push</Select.Option>
                <Select.Option value="email">Email</Select.Option>
              </Select>
            </Form.Item>
            <div className="mb-3">
              <a href="/announcement.csv" style={{ color: "#1777ff" }}>
                <i className="ti ti-ti ti-download"></i>Download sample csv
              </a>
            </div>
            <Form.Item
              name="csv"
              label="Upload CSV"
              extra="Upload a CSV file (optional)"
            >
              <Upload.Dragger
                name="csv"
                listType="text"
                fileList={csvFileList}
                beforeUpload={(file) => {
                  const isCsv =
                    file.type === "text/csv" || file.name.endsWith(".csv");
                  if (!isCsv) {
                    message.error("You can only upload CSV files!");
                    return false;
                  }
                  return false; // Prevent auto upload
                }}
                onChange={({ fileList: newFileList }) => {
                  setCsvFileList(newFileList.slice(-1)); // Only one file
                }}
                onRemove={() => {
                  setCsvFileList([]);
                }}
                accept=".csv,text/csv"
                maxCount={1}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag CSV to this area to upload
                </p>
              </Upload.Dragger>
            </Form.Item>
            <Form.Item
              name="date"
              label="Date"
              rules={[{ required: true, message: "Please select a date!" }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showTime
                format="YYYY-MM-DD HH:mm"
                allowClear
                placeholder="Select date and time"
              // renderExtraFooter={() => (
              //   <Button
              //     type="link"
              //     onClick={() => notifyForm.setFieldsValue({ date: new Date() })}
              //   >
              //     Now1
              //   </Button>
              // )}
              />
            </Form.Item>
          </Form>
        </Modal>
        <DeleteModal handleDelete={handleDelete} />
      </div>
    </div>
  );
};

export default AnnouncementList;
